module.exports = __webpack_public_path__ + "img/Rookie-1.359eb522.gif";